import BaseInput from 'app/components/forms/base_input/component'
import {
  firstElementOrEmptyString,
  withValidation,
} from 'app/components/forms/util'
import * as validations from 'app/shared_components/validations'

export const validateEmailFlattened = (value) =>
  firstElementOrEmptyString(validations.validateEmail(value))

const InputEmail = withValidation(BaseInput, validateEmailFlattened)

export default InputEmail
